import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox, Inscription, useResponsive } from '@common-fe/common-fe';

import useMFAStore from '@/modules/user/components/SignIn/MultiFactorAuthentication/stores/useMFA.store';

interface Props {
  testId?: string;
}

const RememberMeCheckbox: React.FC<Props> = ({ testId }) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { isRememberMe, setIsRememberMe } = useMFAStore();

  const handleSetIsRememberMe = useCallback(() => {
    setIsRememberMe(!isRememberMe);
  }, [setIsRememberMe, isRememberMe]);

  return (
    <Box fill={isMobile} margin={isMobile ? { bottom: 'spacing12' } : undefined}>
      <Checkbox checked={isRememberMe} onChange={handleSetIsRememberMe}>
        <Inscription
          data-testId={`${testId}_remember-this-device-checkbox`}
          onClick={handleSetIsRememberMe}
          size="medium"
        >
          {t('Remember this device')}
        </Inscription>
      </Checkbox>
    </Box>
  );
};

export default RememberMeCheckbox;
